import { createSlice  } from '@reduxjs/toolkit'

const initialState = {
    reportList: {
      requesting: false,
      items: [],
      error: null,
      success: false,
    },
    reportDetails: {
      requesting: false,
      error: null,
      success: false,
      data: null
    },
  };

export const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    getReportList: (state) => {
        state.reportList.requesting = true;
        state.reportList.error = null;
        state.reportList.items = [];
        state.reportList.success = false;
    },
    getReportListSuccess: (state, action) => {
        state.reportList.requesting = false;        
        state.reportList.items = action.payload;
        state.reportList.success = true; 
    },
    getReportListFail: (state, action) => {        
        state.reportList.requesting = false;
        state.reportList.error = action.payload;
    },
    getReportDetails: (state) => {
        state.reportDetails.requesting = true;
        state.reportDetails.error = null;
        state.reportDetails.data = null;
        state.reportDetails.success = false; 
    },
    getReportDetailsSuccess: (state, action) => {
        state.reportDetails.requesting = false;
        state.reportDetails.data = action.payload;
        state.reportDetails.success = true; 
    },
    getReportDetailsFail: (state, action) => {        
        state.reportDetails.requesting = false;
        state.reportDetails.error = action.payload;
    },
    doReportCreate: (state) => {
        state.reportDetails.requesting = true;
        state.reportDetails.error = null;
        state.reportDetails.data = null;
        state.reportDetails.success = false; 
    },
    doReportUpdate: (state) => {
        state.reportDetails.requesting = true;
        state.reportDetails.error = null;
        state.reportDetails.data = null;
        state.reportDetails.success = false; 
    },
    doReportDelete: (state) => {
        state.reportDetails.requesting = true;
        state.reportDetails.error = null;
        state.reportDetails.data = null;
        state.reportDetails.success = false; 
    },
  },
})

export const { 
    getReportList, getReportListSuccess, getReportListFail,
    getReportDetails, getReportDetailsSuccess, getReportDetailsFail,
    doReportCreate, doReportUpdate, doReportDelete
} = reportSlice.actions

export default reportSlice.reducer